import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ZAxis"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 16.5V19.1895L12.75 12.4395V4.371L14.6895 6.3105L15.75 5.25L12 1.5L8.25 5.25L9.3105 6.3105L11.25 4.371V12.4395L4.5 19.1895V16.5H3V21.75H8.25V20.25H5.5605L12 13.8105L18.4395 20.25H15.75V21.75H21V16.5H19.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ZAxis.vue"]]);
